module.exports = __webpack_public_path__ + "static/media/download-icon.a658bdd6.svg";